// 날짜 형식 변환 함수
export function formatReservationDate(dateString) {
  const date = new Date(dateString);
  
  const year = date.getFullYear(); // 연도
  const month = date.getMonth() + 1; // 월 (0부터 시작하므로 +1)
  const day = date.getDate(); // 일
  const hours = date.getHours(); // 시
  const minutes = date.getMinutes().toString().padStart(2, '0'); // 분 (두 자리로)
  
  // 오전/오후 구분
  const period = hours < 12 ? '오전' : '오후';
  const formattedHours = hours % 12 || 12; // 12시간제로 변환 (0시를 12시로 처리)
  
  // 한국어 형식으로 조합
  return `${year}년 ${month}월 ${day}일 ${period} ${formattedHours}:${minutes}`;
}